import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Box, ThemeProvider } from '@mui/material';
import { lightTheme } from '../theme/theme';
import CanvasBoard from './components/CanvasBoard';
import Toolbar from './components/Toolbar';
import PropertiesPanel from './components/PropertiesPanel';
import OrientationSelector from './components/OrientationSelector';
import ExportDialog from './components/ExportDialog';
import BackgroundSelector from './components/BackgroundSelector';
import {
  fetchBackgroundTemplates,
  fetchAssets,
  fetchMenuItems,
} from './redux/slices/assetsSlice';

const CanvasEditor = () => {
  const dispatch = useDispatch();
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const [backgroundSelectorOpen, setBackgroundSelectorOpen] = useState(false);
  
  // Fetch initial assets on mount
  useEffect(() => {
    dispatch(fetchBackgroundTemplates());
    dispatch(fetchAssets());
    dispatch(fetchMenuItems());
  }, [dispatch]);
  
  return (
    <ThemeProvider theme={lightTheme}>
      <Box
        sx={{
          width: '100vw',
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#F6F6F6',
          overflow: 'hidden',
        }}
      >
        {/* Top Bar */}
        <Box
          sx={{
            padding: 2,
            backgroundColor: 'white',
            borderBottom: '1px solid #E0E0E0',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Toolbar
              onOpenBackgroundSelector={() => setBackgroundSelectorOpen(true)}
              onOpenExportDialog={() => setExportDialogOpen(true)}
            />
          </Box>
        </Box>
        
        {/* Orientation & Mode Selector */}
        <Box
          sx={{
            padding: 2,
            backgroundColor: '#F6F6F6',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <OrientationSelector />
        </Box>
        
        {/* Main Content Area */}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            overflow: 'hidden',
          }}
        >
          {/* Canvas Area */}
          <Box
            sx={{
              flex: 1,
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <CanvasBoard />
          </Box>
          
          {/* Properties Panel */}
          <PropertiesPanel />
        </Box>
        
        {/* Dialogs */}
        <ExportDialog
          open={exportDialogOpen}
          onClose={() => setExportDialogOpen(false)}
        />
        
        <BackgroundSelector
          open={backgroundSelectorOpen}
          onClose={() => setBackgroundSelectorOpen(false)}
        />
      </Box>
    </ThemeProvider>
  );
};

export default CanvasEditor;



